var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background" },
    [
      _c(
        "v-row",
        { staticClass: "px-16 mb-12", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "page-header" }, [
                        _vm._v("Global Fuel Rates For All Contracts"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mb-2" },
                _vm._l(_vm.availableTabs, function (tab, i) {
                  return _c(
                    "v-col",
                    {
                      key: tab,
                      staticClass: "details-tab mr-4",
                      class: {
                        active: _vm.currentTab == tab,
                        "pl-0": i == 0,
                      },
                      attrs: {
                        xl: "auto",
                        lg: "auto",
                        md: "auto",
                        sm: "auto",
                        cols: "7",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.tabClicked(tab)
                        },
                      },
                    },
                    [
                      _c("label", [_vm._v(_vm._s(tab))]),
                      _c("span", { staticClass: "counter" }, [
                        _vm._v(_vm._s(_vm.getTabCounter(tab))),
                      ]),
                    ]
                  )
                }),
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "5" } },
                    [
                      _c("smart-text-field", {
                        directives: [
                          {
                            name: "debounce",
                            rawName: "v-debounce:300ms",
                            value: _vm.applyFilters,
                            expression: "applyFilters",
                            arg: "300ms",
                          },
                        ],
                        staticClass: "contracts-search",
                        attrs: {
                          placeholder: "Search",
                          search: true,
                          clearable: true,
                          "background-color": "white",
                        },
                        on: {
                          clear: function ($event) {
                            return _vm.applyFilters("")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("smart-btn", {
                        staticClass: "fr mt-n2",
                        class: {
                          "w-100-pct mt-4": _vm.smAndDown,
                          "mr-4 export-csv": _vm.mdAndUp,
                        },
                        attrs: {
                          icon: _vm.ic_download,
                          label: "Export CSV",
                          "icon-class": "mr-2",
                          "icon-position": "left",
                          "icon-width": "18",
                          bg: "white",
                          border: "navy-blue",
                          font: "navy-blue",
                        },
                        on: { click: _vm.csvExport },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-6" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "claims-grid-wrapper pl-3 br-10" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("fuel-rates-grid", {
                                on: {
                                  edit: _vm.edit,
                                  viewHistory: _vm.viewHistory,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.pagingLength > 1
                ? _c(
                    "v-row",
                    { staticClass: "mt-6", attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "auto" } },
                        [
                          _c("v-pagination", {
                            key: _vm.currentTab + _vm.searchIndex,
                            staticClass: "pl-3",
                            attrs: {
                              length: _vm.pagingLength,
                              "total-visible": "10",
                            },
                            on: { input: _vm.pageChange },
                            model: {
                              value: _vm.currentPage,
                              callback: function ($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("smart-toast", {
        attrs: { display: _vm.snackbar, message: _vm.snackbarText },
        on: {
          close: function ($event) {
            _vm.snackbar = false
          },
        },
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px", scrollable: "", eager: "" },
          model: {
            value: _vm.showEditForm,
            callback: function ($$v) {
              _vm.showEditForm = $$v
            },
            expression: "showEditForm",
          },
        },
        [
          _c("update-fuel-rate", {
            on: {
              close: function ($event) {
                _vm.showEditForm = false
              },
              fuelRateSaved: _vm.fuelRateSaved,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px", scrollable: "", eager: "" },
          model: {
            value: _vm.showHistoryView,
            callback: function ($$v) {
              _vm.showHistoryView = $$v
            },
            expression: "showHistoryView",
          },
        },
        [
          _c("fuel-rate-history", {
            on: {
              close: function ($event) {
                _vm.showHistoryView = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v("Loading Fuel Rates"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }